/**
 * Strix Healthcare — Application Entry Point
 *
 * Wraps the app with:
 * - ClerkProvider (only when VITE_CLERK_PUBLISHABLE_KEY is configured)
 * - AuthProvider (demo auth fallback when Clerk is not configured)
 * - TrpcProvider (tRPC + React Query)
 * - GovernanceProvider (CPF approval modal + proof receipts)
 * - ErrorBoundary (catches unhandled React errors)
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { AuthProvider } from './contexts/AuthContext';
import { GovernanceProvider } from './contexts/GovernanceContext';
import { TrpcProvider } from './lib/trpc';
import { ErrorBoundary } from './components/ErrorBoundary';
import App from './App';
import './index.css';

const CLERK_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

const tree = (
  <ErrorBoundary>
    <AuthProvider>
      <TrpcProvider>
        <GovernanceProvider>
          <App />
        </GovernanceProvider>
      </TrpcProvider>
    </AuthProvider>
  </ErrorBoundary>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {CLERK_KEY ? <ClerkProvider publishableKey={CLERK_KEY}>{tree}</ClerkProvider> : tree}
  </React.StrictMode>,
);
